/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmbedUrlResponse } from '../models';
// @ts-ignore
import type { EmbedUrlV2Response } from '../models';
// @ts-ignore
import type { PaymentMethod } from '../models';
// @ts-ignore
import type { Provider } from '../models';
// @ts-ignore
import type { Theme } from '../models';
/**
 * MetabaseApi - axios parameter creator
 * @export
 */
export const MetabaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a signed URL for embedding Metabase dashboard with optional filters
         * @summary Generate Metabase embed URL
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedUrl: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, provider?: Array<Provider>, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/metabase/embed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a signed URL for embedding specific Metabase dashboards with type-specific filters
         * @summary Generate Metabase embed URL (V2)
         * @param {GetEmbedUrlV2DashboardTypeEnum} dashboardType Dashboard type to embed
         * @param {string} [businessId] Business ID filter (comma-separated for multiple)
         * @param {string} [startDate] Start date for date range filter
         * @param {string} [endDate] End date for date range filter
         * @param {string} [providers] External providers (comma-separated). HOME_PAGE supports all, EXTERNAL_PROVIDER supports only wolt,foodora,bolt
         * @param {string} [userTimezone] User timezone
         * @param {GetEmbedUrlV2ThemeEnum} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedUrlV2: async (dashboardType: GetEmbedUrlV2DashboardTypeEnum, businessId?: string, startDate?: string, endDate?: string, providers?: string, userTimezone?: string, theme?: GetEmbedUrlV2ThemeEnum, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardType' is not null or undefined
            assertParamExists('getEmbedUrlV2', 'dashboardType', dashboardType)
            const localVarPath = `/api/v2/metabase/embed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dashboardType !== undefined) {
                localVarQueryParameter['dashboardType'] = dashboardType;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (providers !== undefined) {
                localVarQueryParameter['providers'] = providers;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetabaseApi - functional programming interface
 * @export
 */
export const MetabaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetabaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a signed URL for embedding Metabase dashboard with optional filters
         * @summary Generate Metabase embed URL
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedUrl(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, provider?: Array<Provider>, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbedUrl(businessId, startDate, endDate, userTimezone, provider, theme, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseApi.getEmbedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a signed URL for embedding specific Metabase dashboards with type-specific filters
         * @summary Generate Metabase embed URL (V2)
         * @param {GetEmbedUrlV2DashboardTypeEnum} dashboardType Dashboard type to embed
         * @param {string} [businessId] Business ID filter (comma-separated for multiple)
         * @param {string} [startDate] Start date for date range filter
         * @param {string} [endDate] End date for date range filter
         * @param {string} [providers] External providers (comma-separated). HOME_PAGE supports all, EXTERNAL_PROVIDER supports only wolt,foodora,bolt
         * @param {string} [userTimezone] User timezone
         * @param {GetEmbedUrlV2ThemeEnum} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedUrlV2(dashboardType: GetEmbedUrlV2DashboardTypeEnum, businessId?: string, startDate?: string, endDate?: string, providers?: string, userTimezone?: string, theme?: GetEmbedUrlV2ThemeEnum, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbedUrlV2(dashboardType, businessId, startDate, endDate, providers, userTimezone, theme, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseApi.getEmbedUrlV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetabaseApi - factory interface
 * @export
 */
export const MetabaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetabaseApiFp(configuration)
    return {
        /**
         * Creates a signed URL for embedding Metabase dashboard with optional filters
         * @summary Generate Metabase embed URL
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedUrl(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, provider?: Array<Provider>, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlResponse> {
            return localVarFp.getEmbedUrl(businessId, startDate, endDate, userTimezone, provider, theme, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a signed URL for embedding specific Metabase dashboards with type-specific filters
         * @summary Generate Metabase embed URL (V2)
         * @param {GetEmbedUrlV2DashboardTypeEnum} dashboardType Dashboard type to embed
         * @param {string} [businessId] Business ID filter (comma-separated for multiple)
         * @param {string} [startDate] Start date for date range filter
         * @param {string} [endDate] End date for date range filter
         * @param {string} [providers] External providers (comma-separated). HOME_PAGE supports all, EXTERNAL_PROVIDER supports only wolt,foodora,bolt
         * @param {string} [userTimezone] User timezone
         * @param {GetEmbedUrlV2ThemeEnum} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedUrlV2(dashboardType: GetEmbedUrlV2DashboardTypeEnum, businessId?: string, startDate?: string, endDate?: string, providers?: string, userTimezone?: string, theme?: GetEmbedUrlV2ThemeEnum, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV2Response> {
            return localVarFp.getEmbedUrlV2(dashboardType, businessId, startDate, endDate, providers, userTimezone, theme, paymentMethod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetabaseApi - object-oriented interface
 * @export
 * @class MetabaseApi
 * @extends {BaseAPI}
 */
export class MetabaseApi extends BaseAPI {
    /**
     * Creates a signed URL for embedding Metabase dashboard with optional filters
     * @summary Generate Metabase embed URL
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseApi
     */
    public getEmbedUrl(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, provider?: Array<Provider>, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseApiFp(this.configuration).getEmbedUrl(businessId, startDate, endDate, userTimezone, provider, theme, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a signed URL for embedding specific Metabase dashboards with type-specific filters
     * @summary Generate Metabase embed URL (V2)
     * @param {GetEmbedUrlV2DashboardTypeEnum} dashboardType Dashboard type to embed
     * @param {string} [businessId] Business ID filter (comma-separated for multiple)
     * @param {string} [startDate] Start date for date range filter
     * @param {string} [endDate] End date for date range filter
     * @param {string} [providers] External providers (comma-separated). HOME_PAGE supports all, EXTERNAL_PROVIDER supports only wolt,foodora,bolt
     * @param {string} [userTimezone] User timezone
     * @param {GetEmbedUrlV2ThemeEnum} [theme] Dashboard theme
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseApi
     */
    public getEmbedUrlV2(dashboardType: GetEmbedUrlV2DashboardTypeEnum, businessId?: string, startDate?: string, endDate?: string, providers?: string, userTimezone?: string, theme?: GetEmbedUrlV2ThemeEnum, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseApiFp(this.configuration).getEmbedUrlV2(dashboardType, businessId, startDate, endDate, providers, userTimezone, theme, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetEmbedUrlV2DashboardTypeEnum = {
    home_page: 'home-page',
    pos: 'pos',
    munchi_online: 'munchi-online',
    munchi_kiosk: 'munchi-kiosk',
    external_provider: 'external-provider'
} as const;
export type GetEmbedUrlV2DashboardTypeEnum = typeof GetEmbedUrlV2DashboardTypeEnum[keyof typeof GetEmbedUrlV2DashboardTypeEnum];
/**
 * @export
 */
export const GetEmbedUrlV2ThemeEnum = {
    light: 'light',
    night: 'night'
} as const;
export type GetEmbedUrlV2ThemeEnum = typeof GetEmbedUrlV2ThemeEnum[keyof typeof GetEmbedUrlV2ThemeEnum];
